import { isServiceEnabled } from './serviceGate';

// 設為空字串或未設定時走相對路徑（同源／CRA dev proxy），避免部署版固化 localhost。
// 本機若需直連 Gateway，請明確設定 REACT_APP_API_BASE（例如 http://localhost:8090）。
const rawApiBase = process.env.REACT_APP_API_BASE;
const API_BASE =
  rawApiBase === undefined || rawApiBase === null || rawApiBase === ''
    ? ''
    : String(rawApiBase).replace(/\/$/, '');

/** 前台會員 BFF（formosa-member） */
export const MEMBER_API = `${API_BASE}/formosa-member/member`;

/** 後台管理 BFF（formosa-admin）— 僅 admin 應用使用 */
export const ADMIN_API = `${API_BASE}/formosa-admin/admin`;

/** 下單服務（formosa-order），前台以會員 Token 呼叫 */
export const ORDER_API = `${API_BASE}/formosa-order/order`;

/** 支付服務（formosa-payment）— 前台不直連，走 MEMBER_API BFF */
export const PAYMENT_API = `${API_BASE}/formosa-payment/payment`;

/** 行情服務（formosa-market） */
export const MARKET_API = `${API_BASE}/formosa-market/market`;

/**
 * IM 服務（formosa-im）。Gateway Path=/im/**，不 RewritePath。
 * HTTP: /im/conversations/...  WebSocket: /im/ws
 */
export const IM_API = `${API_BASE}/im`;

function resolveImWsUrl() {
  const configured = process.env.REACT_APP_IM_WS_URL;
  if (configured) {
    return configured.replace(/\/$/, '');
  }
  const base =
    API_BASE ||
    (typeof window !== 'undefined' && window.location?.origin ? window.location.origin : '');
  if (!base) {
    return '';
  }
  try {
    const url = new URL(base.startsWith('http') ? base : `http://${base}`);
    const protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${url.host}/im/ws`;
  } catch {
    return '';
  }
}

/** Native WebSocket base（不含 query token）；IM 停用（REACT_APP_DISABLED_SERVICES 含 im）時為空字串 */
export const IM_WS_URL = isServiceEnabled('im') ? resolveImWsUrl() : '';

/** formosa-order Socket.IO（獨立端口，非 Gateway） */
function resolveOrderSocketUrl() {
  const configured = process.env.REACT_APP_ORDER_SOCKET_URL;
  if (configured) {
    return configured.replace(/\/$/, '');
  }
  // 與 API_BASE／目前頁面同源推導；明確覆寫請用 REACT_APP_ORDER_SOCKET_URL
  const base =
    API_BASE ||
    (typeof window !== 'undefined' && window.location?.origin ? window.location.origin : '');
  if (!base) {
    return '';
  }
  try {
    const url = new URL(base.startsWith('http') ? base : `http://${base}`);
    return `${url.protocol}//${url.hostname}:8106`;
  } catch {
    return '';
  }
}

/** Order Socket.IO；order 停用時為空字串（訂閱為 no-op，不連線、不重連） */
export const ORDER_SOCKET_URL = isServiceEnabled('order') ? resolveOrderSocketUrl() : '';

/** @deprecated 請改用 MEMBER_API / ADMIN_API */
export const API_PREFIX = {
  member: MEMBER_API,
  admin: ADMIN_API,
  order: ORDER_API,
  payment: PAYMENT_API,
  market: MARKET_API,
  im: IM_API,
};

export { API_BASE };
